import React, { useState, useEffect, useMemo } from 'react';
import useSortableTable from './useSortableTable';
import './SortableTable.css';
import { calculateMarketValue, formatCurrency, formatDecimalPlaces } from './helpers';

function EarningsTable({ stocks, options}) {
  const [earningsData, setEarningsData] = useState([]);

useEffect(() => {
    // Merge both arrays
    const all = [...stocks, ...options];

    // Aggregate by ticker
    const aggregated = all.reduce((acc, item) => {
      const ticker = item.position;
      // Only include stock-based items with earnings data
      if ((item.type === 'stock' || item.type === 'option_stock') && item.details?.EarningsDate && item.details?.Recommendation) {
        if (!acc[ticker]) {
          acc[ticker] = { ...item, stockQty: 0, putsQty: 0, callsQty: 0 };
        }
        // Count specific exposures
        if (item.type === 'stock') {
          acc[ticker].stockQty += Number(item.quantity);
        } else if (item.option_type === 'put') {
          acc[ticker].putsQty += Number(item.quantity);
        } else if (item.option_type === 'call') {
          acc[ticker].callsQty += Number(item.quantity);
        }
      }
      return acc;
    }, {});

    setEarningsData(Object.values(aggregated));
  }, [stocks, options]);

	const columns = useMemo(()=>['position', 'quantity', 'puts','calls','price', 'DFVScore', 'PriceTarget', 'PE', 'FPE', 'RSI', 'EarningsDate','Recommendation'],[]);
  const { sortedData, requestSort, getSortClass } = useSortableTable(earningsData, columns);

  return (
    <div>
      <h2>Upcoming Earnings</h2>
      <div className="table-responsive-wrapper">
      <table>
        <thead>
          <tr>
            <th>Ticker</th>
            <th>Quantity</th>
	    <th>Puts</th>
	    <th>Calls</th>
            <th>Price</th>
            <th onClick={() => requestSort('marketValue')} className={getSortClass('marketValue')}>Market Value</th>
	    <th onClick={() => requestSort('DFVScore')} className={getSortClass('DFVScore')}>DFVScore</th>
            <th>PriceTarget</th>
	    <th onClick={() => requestSort('priceTargetDiff')} className={getSortClass('priceTargetDiff')}>PriceTargetDiff</th>
            <th>PE</th>
            <th>FPE</th>
            <th onClick={() => requestSort('RSI')} className={getSortClass('RSI')}>RSI</th>
            <th>EarningsDate</th>
	    <th>Recommendation</th>
          </tr>
        </thead>
        <tbody>
          {sortedData.map((item, index) => (
            <tr key={index}>
              <td>{item.position}</td>
              <td>{item.stockQty}</td>
	      <td>{item.putsQty}</td>
	      <td>{item.callsQty}</td>
              <td>{formatCurrency(item.details?.Price) || '-'}</td>
	      <td>{formatCurrency(calculateMarketValue(item.stockQty, item.details?.Price))}</td>
              <td>{formatDecimalPlaces(item.details?.DFVScore,2)}</td>
              <td>{item.details?.PriceTarget || '-'}</td>
              <td>{item.details?.PriceTargetDiff || '-'}</td>
              <td>{item.details?.PE || '-'}</td>
              <td>{item.details?.FPE || '-'}</td>
              <td>{item.details?.RSI || '-'}</td>
              <td>{item.details?.EarningsDate || '-'}</td>
              <td>{item.details?.Recommendation || '-'}</td>
	    </tr>
          ))}
        </tbody>
      </table>
      </div>
    </div>
  );
}

export default EarningsTable;
